import { z } from 'zod';

export const supervisorModeSchema = z.enum(['listen', 'whisper', 'barge']);

// These feature codes select the extension's current call at NEW SIP start.
// A clicked UUID is audit context only, never a SIP authorization/correlation token.
export const supervisorPreflightRequestSchema = z.object({
  mode: supervisorModeSchema,
  target_extension: z.string().regex(/^\d{3,4}$/, 'Interno supervisor non valido'),
  target_call_uuid: z.string().uuid().nullable().optional(),
}).strict();

export const supervisorPreflightResponseSchema = z.object({
  success: z.literal(true),
  authorized: z.literal(true),
  phase: z.literal('intent'),
  target_semantics: z.literal('extension_current_call_at_sip_start'),
}).strict();

export type SupervisorMode = z.infer<typeof supervisorModeSchema>;
export type SupervisorPreflightRequest = z.infer<typeof supervisorPreflightRequestSchema>;
export type SupervisorPreflightResponse = z.infer<typeof supervisorPreflightResponseSchema>;
